import React from "react";
import { useSelector } from "react-redux";
import { Spin } from "antd";
import AppModal from "components/ui/AppModal";

const HomeTab = ({ order, isOpen, onClose, children, title }) => {
  const { error } = useSelector((state) => state.ErrorReducer);
  const { isLoading } = useSelector((state) => state.LoaderReducer);

  return (
    <Spin spinning={isLoading}>
      <AppModal
        open={isOpen}
        onClose={onClose}
        title={title}
        titleAlign="center"
        width={720}
        zIndex={3000}
        className="app-modal app-modal-logistics"
        maskStyle={{ backdropFilter: "blur(6px)" }}
      >
        {error && (
          <div className="text-center text-red-500 mt-2 mb-2 font-semibold">
            {error}
          </div>
        )}
        {children}
      </AppModal>
    </Spin>
  );
};

export default HomeTab;
